<template>
  <div :id="sid+chartName" class="chart-wrapper" :style="esize"></div>
</template>
<script>
function rnd(n, m) {
  var random = Math.floor(Math.random() * (m - n + 1) + n);
  return random;
}
let LineColor = [
  "#c23531",
  "#2f4554",
  "#61a0a8",
  "#d48265",
  "#91c7ae",
  "#749f83",
  "#ca8622",
  "#bda29a",
  "#6e7074",
  "#546570",
  "#c4ccd3"
];
export default {
  name: "yearCommon",
  data() {
    return {
      chartName: this.$options.name,
      chartData: [],
      chColor: "#c23531"
    };
  },
  props: {
    choosedOptions: {
      type: Object,
      default() {
        return {
          selectedList: [],
          keyword: ""
        };
      }
    },
    year:{
      style:Number,
      default(){
        let cdate = new Date();
        return cdate.getFullYear();
      }
    },
    sid:{
      type:String,
      default:'a',
    },
    esize: {
      type: Object,
      default() {
        return { height: "15rem", width: "100%" };
      }
    },
    drawAgain: {
      type: Number,
      default: 1
    }
  },
  mounted() {
    let n = rnd(0,LineColor.length-2);
    this.lineColor = LineColor[n];
    this.barColor = LineColor[n+1];
  },
  watch: {
    drawAgain: {
      immediate: true,
      handler(newVal) {
        if (newVal > 0) {
          this.get_data();
        }
      }
    }
  },
  computed: {
    ctdata() {
      return this.chartData;
    },
    title(){
      // if(this.timeRange===1){
      //   return "今日订单数据";
      // }else{
      //   return "近"+this.timeRange+"个工作日订单数据";
      // }
      return this.year+"年度订单数据";
    }
  },
  methods: {
    get_data() {
      let userToken = localStorage.getItem("current_user_token");
      this.$axios
        .post(this.$url + "/statistics", {
          askData: this.chartName,
          choosedOptions: this.choosedOptions,
          year:this.year,
          userToken: userToken
        })
        .then(response => {
          this.chartData = response.data;
          this.chartData.reverse();
          this.drawIt();
          });
    },
    maxNum(){
      let amount = [];
      let price = [];
      for(let ele of this.chartData){
        amount.push(ele.order_quantity);
        price.push(ele.total_price);
      }
      return {amount:Math.max(amount),price:Math.max(price)};
    },
    drawIt() {
      let vm = this;
      let myChart = this.$echarts.init(document.getElementById(vm.sid+vm.chartName));
      // 绘制图表
      myChart.setOption({
        backgroundColor: "#fff",
        title: {
          text: vm.title,
          subtext: '',
          left: "center",
          top: "5%",
          textStyle: {
            fontSize:"0.5rem",
            color: "#888",
            verticalAlign: "top"
          }
        },
        tooltip: {
          trigger: "item"
        },
        grid: {
          x: "15%",
          y: "25%",
          x2: "10%",
          y2: "25%",
          borderWidth: 10
        },
        legend: {
          data: ['订单数', '订单总金额'],
          bottom:'5%'
        },
        toolbox: {
          show: true,
          orient: "vertical",
          left: "right",
          top: "center",
          feature: {
            mark: {
              show: true
            },
            dataView: {
              show: true,
              readOnly: false
            },
            restore: {
              show: true
            },
            saveAsImage: {
              show: true
            }
          }
        },
        dataset: {
          source: vm.ctdata
        },
        xAxis: {
          type: "category",
          axisTick: {
            alignWithLabel: true
          },
        },
        yAxis: [
         
          {
            type:'value',
            name:'订单总金额',
            min:0,
            max:vm.maxNum().price+1000
          },
           {
            type:'value',
            name:'订单数',
            min:0,
            max:vm.maxNum().amount+10
          },
        ],
        series: [
         
          {
            name: "订单总金额",
            type: "bar",
            label: {
              show: false,
              rotate: 90
            },
            tooltip: {
              trigger: "item",
              formatter: function(a){
                return a.seriesName+'</br>'+a.name+'：'+'￥'+(a.data.total_price/10000).toFixed(2)+'万元';
              }
            },
            itemStyle: {
              color: vm.barColor,
              opacity: 0.8,
              shadowBlur: 1,
              shadowColor: "#e6e6e6",
              shadowOffsetX: 2,
              shadowOffsetY: 2
            }
          },
           {
            name: "订单数",
            type: "line",
            yAxisIndex: 1,
            label: {
              show: true,
              rotate: 15
            },
            itemStyle: {
              color: vm.lineColor,
              opacity: 0.8,
              shadowBlur: 1,
              shadowColor: "#e6e6e6",
              shadowOffsetX: 2,
              shadowOffsetY: 2
            }
          },
        ],
        label: {
          normal: {
            textStyle: {
              color: "rgba(255, 255, 255, 0.3)"
            }
          }
        },
        labelLine: {
          normal: {
            lineStyle: {
              color: "rgba(255, 255, 255, 0.3)"
            },
            smooth: 0.2,
            length: 10,
            length2: 20
          }
        }
      });
      /**myChart.on('click', function (value) {
                    vm.$emit("clickToChange", { 'value': [value.name], 'key': vm.chartKey });

                });**/
      myChart.on("legendselectchanged", function(value) {
        vm.$emit("clickToAppend", {
          value: value.selected,
          key: vm.chartName
        });
      });
    }
  }
};
</script>
<style scoped>
.chart-wrapper {
  border: 1px solid #f9f9f9;
  border-radius: 3px;
  margin: 0 auto;
}
</style>